// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nntCC","largestCol":"styles_largestCol__2V7Yo","smallestCol":"styles_smallestCol__2Eyc0"};